import React from 'react';

import './index.less'

export interface RightToolButtonProps {
    [propsName: string]: any
}
const RightToolButton: React.FC<RightToolButtonProps> = (props) => {
    // console.log('RightToolButton的props', props)
    return (
        <div className="toolButton">
            {props.children}
        </div>
    )
}
export default RightToolButton;